import Vue from 'vue'
import axios from 'axios'
import App from './App.vue'
import router from './router'
import store from './store'
import { sync } from 'vuex-router-sync'
import './plugins/base-components'

import './assets/styles/style.scss'
import { DEFAULT_LANG } from '@/helpers/constant'

Vue.config.productionTip = false

const axiosConfig = {
  baseURL: process.env.VUE_APP_API_URL
}
window.axios = axios.create(axiosConfig)

function detectLang () {
  const urlParams = new URLSearchParams(window.location.search)
  const urlLang = urlParams.get('lang')
  const storeLang = store.state.currentLang
  return urlLang || storeLang || DEFAULT_LANG
}

const currentLang = detectLang()
store.commit('SET_CURRENT_LANG', currentLang)
window.axios.defaults.headers.common['Accept-Language'] = currentLang

window.axios.interceptors.request.use(config => {
  const lang = store.state.currentLang || currentLang
  config.headers['Accept-Language'] = lang
  config.params = { ...(config.params || {}), lang }
  return config
})

sync(store, router)
store.watch(
  state => state.currentLang,
  (newLang, oldLang) => {
    if (newLang === oldLang) return

    window.axios.defaults.headers.common['Accept-Language'] = newLang

    const query = { ...router.currentRoute.query }
    if (newLang === DEFAULT_LANG) {
      delete query.lang
    } else {
      query.lang = newLang
    }

    router.replace({
      path: router.currentRoute.path,
      query,
      hash: router.currentRoute.hash
    }).then(() => {
      window.location.reload()
    })
  }
)

Vue.config.devtools = true

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
